import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import { Contract } from "@edp-components/edp-contract";
import { IAppState } from "@edp-store/state/app.state";
import { select, Store } from "@ngrx/store";
import { getUser } from "@edp-store/selectors/user.selectors";
import { take, takeUntil } from "rxjs/operators";
import { environment } from "@edp-environments/environment";
import { Subject } from "rxjs";
import { getContract } from "@edp-store/selectors/contract.selectors";

@Component({
    selector: "edp-header-contract",
    templateUrl: "./edp-header-contract.component.html",
    styleUrls: ["./edp-header-contract.component.scss"],
})
export class EdpHeaderContractComponent implements OnInit, OnDestroy {
    public contract: Contract;
    public basicComponent: any;
    public isElegiblePack: boolean;
    public isApp: boolean;

    private unsubscribe = new Subject();

    constructor(private store: Store<IAppState>) {
        this.isApp = environment.isApp;
    }

    public ngOnInit() {
        this.store.pipe(takeUntil(this.unsubscribe), select(getContract)).subscribe(contract => {
            this.contract = contract;
            if (!!contract.BasicComponent && !!contract.BasicComponent[0]) {
                this.basicComponent = contract.BasicComponent[0];

                this.store
                    .select(getUser)
                    .pipe(take(1))
                    .subscribe(edpUser => {
                        this.isElegiblePack = contract.isElegiblePack(this.basicComponent, edpUser);
                    });
            }
        });
    }

    public ngOnDestroy() {
        this.unsubscribe.next();
        this.unsubscribe.complete();
    }
}
